
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CaseStudiesGrid from './components/CaseStudiesGrid';
import ResultsSection from './components/ResultsSection';
import CTASection from './components/CTASection';

const CaseStudiesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <CaseStudiesGrid />
        <ResultsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default CaseStudiesPage;
